'use client'

import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { useTranslations } from 'next-intl'

const RefundInfo: React.FC = () => {
    const t = useTranslations('srpFlightDetails')

    return (
        <TableContainer
            component={Paper}
            sx={{
                border: '1px solid #E0E0E0',
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: 'none'
            }}
        >
            <Table>
                <TableHead>
                    <TableRow sx={{ backgroundColor: '#F9FAFB' }}>
                        <TableCell sx={{ fontWeight: 600 }}>
                            {t('standardFarePerTraveler')}
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell sx={{ p: 2, fontWeight: 500 }}>
                            {t('nonRefundableInfo')}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default RefundInfo